module.exports = __webpack_public_path__ + "static/media/mute_white.4ace1e05.svg";